export default function Solutions() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="soluzioni" className="relative py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/88ae04d7131d5a2fbb52acb6005eae00.jpg" 
          alt="Ufficio moderno" 
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-6xl font-bold text-white leading-tight mb-8 lowercase" style={{ fontFamily: 'Inter, sans-serif' }}>
              inizia oggi<br />
              la tua<br />
              trasformazione hr
            </h2>
            <button 
              onClick={() => scrollToSection('contatti')}
              className="inline-flex items-center gap-4 px-8 py-4 bg-white text-gray-900 text-base font-semibold rounded-full hover:bg-gray-100 transition-all duration-300 whitespace-nowrap cursor-pointer group"
            >
              Contattaci Ora
              <div className="w-11 h-11 bg-gray-900 rounded-full flex items-center justify-center">
                <i className="ri-arrow-right-line text-white text-lg group-hover:translate-x-1 transition-transform"></i>
              </div>
            </button>
          </div>

          <div className="text-right">
            <p className="text-2xl text-white font-light leading-relaxed">
              Contattaci per una consulenza gratuita<br />
              Soluzioni personalizzate in 48 ore
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}